import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=3de159ca&scoped=true&"
import script from "./addCustom.vue?vue&type=script&lang=js&"
export * from "./addCustom.vue?vue&type=script&lang=js&"
import style0 from "./addCustom.vue?vue&type=style&index=0&id=3de159ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de159ca",
  null
  
)

export default component.exports